import { Col, Row, Slider, Container } from '@microfrontends/react-components'
import { useContext } from 'react'
import { bookNumerology } from '../../../components/NumerologyV2/const'
import Title from '../../../components/NumerologyV2/Title'
import WindowBox from '../../../components/NumerologyV2/WindowBox'
import AppContext from '../../../context/AppContext'
import { EDevice } from '../../MainLayout'
import { BooksCss, Box } from '../Numerology.css'

export default function Books() {
	const { breakpoint } = useContext(AppContext)
	return (
		<Container>
			<BooksCss justify={'center'} align='middle' gutter={20}>
				<Col>
					<Box className='center'>
						<Title
							title='Một số đầu sách về nhân số học'
							marker='star'
							backgound='oval'
						/>
					</Box>
				</Col>
				<Col>
					<Row justify={'center'} align='middle' gutter={[20, 20]}>
						<Col>
							<Slider
								id='Slider-test-2'
								slides={{
									elementPerView:
										breakpoint !== EDevice.MOBILE ? 4 : 1
								}}
								autoEnable={
									breakpoint !== EDevice.MOBILE ? false : true
								}
								autoTime={4000}
								pagination={{ maxShow: 3 }}
								container={{
									style: { width: '100%' }
								}}
							>
								{bookNumerology.map((book, index) => {
									return (
										// <a
										// 	key={index}
										// 	href={book.link}
										// 	target='_blank'
										// 	rel='noopener noreferrer'
										// >
										<Box className='center' key={index}>
											<WindowBox
												type='book'
												item={book}
												style={{
													padding: '20px 0',
													margin: '0 auto'
												}}
											/>
										</Box>
										// </a>
									)
								})}
							</Slider>
						</Col>
					</Row>
				</Col>
			</BooksCss>
		</Container>
	)
}
